import type Big from 'big.js'

import {useAccountInformationValue} from '@/auth/hooks/useAccountInformation'
import {getCashback} from '@/lib/payment/paymentService'
import {NO_REFETCH_OPTIONS} from '@/utils/query/constants'

export default function useCashback(amount: number | Big) {
  const account = useAccountInformationValue()

  return useQuery({
    queryKey: ['cashback', account?.id, amount],
    queryFn: account?.id
      ? async ({signal}) =>
          getCashback({
            amount: typeof amount === 'number' ? amount : amount.toNumber(),
            signal,
          })
      : skipToken,
    placeholderData: prev => prev,
    ...NO_REFETCH_OPTIONS,
  })
}
